import React from "react";

function GotoLogin() {
  return (
    <div className="goto-login-block">
      <div className="goto-login mycard">
        <div>Login / Signup to add movies to your list.</div>
      </div>
    </div>
  );
}

export default GotoLogin;
